import React, { useEffect, useState, useLayoutEffect } from "react";
import { Spinner, Row, Col } from "react-bootstrap";

import { useNavigate, useLocation } from "react-router-dom";
import "./TeamMemberDetail.scss";
import { fetchTeamMemberLogo } from "services/UserManagementServices";
import { useTranslation } from "react-i18next";
const TeamMemberDetail = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const { pathIds, teamData = {} } = location.state;

  const [teamLogo, setTeamLogo] = useState({
    url: null,
    isFetching: false,
  });
  const onNavigate = () => {
    navigate(`/branch-detail/teams`, { state: { pathIds } });
  };
  const getTeamMemberDetail = async () => {
    setTeamLogo({ ...teamLogo, isFetching: true });
    let teamLogoResult = await fetchTeamMemberLogo(
      teamData?.consultantProfileImage
    );
    if (teamLogoResult?.status === 200)
      setTeamLogo({
        url: URL.createObjectURL(teamLogoResult.data),
        isFetching: false,
      });
  };
  useLayoutEffect(() => {
    getTeamMemberDetail();
  }, []);

  return (
    <>
      <div className="eg-user claims">
        <div className="custom-breadcrumbs mx-5 px-2">
          <span
            className="breadcrumbs-item "
            onClick={() => {
              onNavigate();
            }}
          >
            {t("teams")}
          </span>
          <span className="breadcrumbs-item ">
            <p>
              {teamData?.firstName} {teamData?.lastName}
            </p>
          </span>
        </div>
        <br />
        <Row>
          <Col lg={6} sm={12}>
            <div className="d-flex role">
              <div className="circle-icon">
                {(teamLogo.isFetching && (
                  <Spinner
                    className="loader"
                    animation="border"
                    aria-hidden="true"
                    as="span"
                    size="sm"
                  />
                )) ||
                  (teamLogo.url && <img alt="not found" src={teamLogo.url} />)}
              </div>
              <span className="ms-2">
                <b>{teamData?.firstName + " " + teamData?.lastName}</b>
              </span>
            </div>
            <br />
            <div style={{ marginLeft: "10%" }}>
              <h4 className="mt-2">{t("description")}</h4>
              <span className="paragraph ">
                {teamData?.description}
              </span> <br /> <br />
            </div>
          </Col>
          <Col lg={1} sm={12}></Col>
          <Col lg={5} sm={12}>
            <div>
              <h4 className="mt-7 education">{t("education")}</h4>
              <span dangerouslySetInnerHTML={{ __html: teamData?.education }} />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default TeamMemberDetail;
